import { useI18n } from "@/lib/i18n";
import { cn } from "@/lib/utils";

/**
 * Two-button language pill, lives in the dashboard header next to the
 * theme toggle. Mirrors the visual recipe used by `ThemeToggle` (pill
 * with two segmented options) so the header reads as one coherent
 * control cluster.
 */
export function LangToggle({ className }: { className?: string }) {
  const { lang, setLang, t } = useI18n();
  return (
    <fieldset
      aria-label={t("toggle.lang")}
      className={cn(
        "inline-flex h-7 items-center rounded-md border border-border/70 bg-card p-0.5 text-[11px] font-medium",
        className,
      )}
    >
      <button
        type="button"
        onClick={() => setLang("en")}
        aria-pressed={lang === "en"}
        className={cn(
          "h-6 rounded-[3px] px-2 text-muted-foreground transition",
          lang === "en" && "bg-muted text-foreground shadow-sm",
        )}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLang("zh")}
        aria-pressed={lang === "zh"}
        className={cn(
          "h-6 rounded-[3px] px-2 text-muted-foreground transition",
          lang === "zh" && "bg-muted text-foreground shadow-sm",
        )}
      >
        中
      </button>
    </fieldset>
  );
}
